module.exports = __webpack_public_path__ + "static/media/bronze.fa0e05e5.svg";